import React, { useEffect, useState,useRef } from "react";

import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import { Growl } from 'primereact/growl';
import Dropzone from 'react-dropzone';

import servicioObjetos from '../../servicio/ServicioObjetos';
import { obtenerObjetoBase64Archivos } from '../../servicio/ServicioLecturaArchivos';
import { validacionCertificadosDigitales } from '../../servicio/ServicioValidacionCertificadosDigitales';
import {ModalResponseAuthIdseImms} from './ModalResponseAuthIdseImms';
import  servicioHttp  from '../../servicio/ServicioHttp';
import forge from 'node-forge';

const MENSAJE_PFX = "Arrastra tu Certificado .PFX o da click aquí";
const MENSAJE_FIEL = "Arrastra tu FIEL(.cer y .key) o da click aquí";
const ACEPTAR_PFX = ".pfx";
const ACEPTAR_FIEL = ".cer,.key";


export const ModalEditarCertificadosEmpresa = (props) => {

    const { empresaEditar, mostrarModal, funcionCerrarModal } = props;

    const [empresa, setEmpresa] = useState({});
    const [errores, setErrores] = useState({});
    const [archivoPfx, setArchivoPfx] = useState({});
    const [archivoCer, setArchivoCer] = useState({});
    const [archivoKey, setArchivoKey] = useState({});
    const [mostrarModalAuthResponse,setMostrarModalAuthResponse]=useState(false);
    const [objetoResponseAuth,setObjetoResponseAuth]=useState({});
    let growl = useRef(null);

    useEffect(() => {
        let laEmpresa = {};
        laEmpresa.id=empresaEditar.id;
        laEmpresa.usuario = null;
        laEmpresa.registroPatronal=empresaEditar.registroPatronal;
        setEmpresa(laEmpresa);
        setErrores({});
    }, [empresaEditar]);

    const handleChange = (e, mayusculas) => {
        const { name, value } = e.target;
        let elValor = value;
        if (mayusculas) {
            if (elValor && typeof elValor !== 'object')
                elValor = elValor.toUpperCase();
        }
        setEmpresa(valoresPrevios => ({
            ...valoresPrevios,
            [name]: elValor
        }));
    };

    const cerrar = () => {
        funcionCerrarModal();
    }

    const actualizarCertificados = () => {
        const validacion = validarFormulario();
        setErrores(validacion);
        if (servicioObjetos.esObjetoVacio(validacion)) {
            let empresaEnvio = {};
            empresaEnvio.id = empresa.id;
            empresaEnvio.usuario = empresa.usuario;
            empresaEnvio.contrasena = empresa.contrasenaPfx;
            empresaEnvio.archivoPfx = archivoPfx.stringBase64;
            empresaEnvio.certificadorCer = archivoCer.stringBase64;
            empresaEnvio.certificadoKey = archivoKey.stringBase64;
            empresaEnvio.contraseniaFiel = empresa.contrasenaFiel;
            empresaEnvio.rfcFiel = empresa.rfcFiel;
            empresaEnvio.fechaCreacion = empresa.fechaCreacion;
            empresaEnvio.fechaExpiracion = empresa.fechaExpiracion;
            empresaEnvio.nombreArchivo = archivoPfx.nombre;
            empresaEnvio.tipoCertificado = empresa.tipoCertificado;
            empresaEnvio.registroPatronal=empresa.registroPatronal;
            if(empresaEnvio.tipoCertificado === 'fiel'){
                empresaEnvio.usuario = null;
                empresaEnvio.contrasena = null;
                empresaEnvio.archivoPfx = null;
            }
            servicioHttp.consumirPostHttp("empresa/actualizar_certificados.json", empresaEnvio).then(response => {
                growl.current.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                let {objeto}=response.data;

                if(!servicioObjetos.esObjetoVacio(objeto)){
                    setMostrarModalAuthResponse(true);
                    setObjetoResponseAuth(objeto);
                }
                if (!response.data.error) {
                    funcionCerrarModal();
                    cerrarModalAuth();
                }
            }).catch(error => {
                growl.current.show({ severity: 'error', summary: '', detail: 'Se generó un error inesperado!!!, por favor inténtelo de nuevo' });
            })
        }
    }

    const validarFormulario = () => {
        const errores = {};

        if (servicioObjetos.esObjetoVacio(empresa.tipoCertificado))
            errores.tipoCertificado = "Campo requerido";

        if (!servicioObjetos.esObjetoVacio(empresa.tipoCertificado)) {
            if (empresa.tipoCertificado === 'pfx') {
                if (servicioObjetos.esObjetoVacio(empresa.usuario))
                    errores.usuario = "Campo requerido";        

                if(servicioObjetos.esObjetoVacio(empresa.contrasenaPfx)){
                    errores.contrasenaPfx="Campo requerido";
                }
                if (servicioObjetos.esObjetoVacio(archivoPfx)) {
                    errores.tipoCertificado = "Debes de cargar un archivo .pfx";
                } else {
                    const validacionPfx = validarCertificadoPfx(archivoPfx.stringBase64, empresa.contrasenaPfx);
                    empresa.fechaExpiracion = validacionPfx.fecha;
                    if (validacionPfx.error) {
                        errores.contrasenaPfx = validacionPfx.descripcionError;
                    }
                }
            }

            if (empresa.tipoCertificado === 'fiel') {
                if (servicioObjetos.esObjetoVacio(archivoCer) || servicioObjetos.esObjetoVacio(archivoKey)) {
                    errores.tipoCertificado = "No has cargado .cer o .key";
                }  
                
                if (servicioObjetos.esObjetoVacio(empresa.rfcFiel)) {
                    errores.rfcFiel = "El rfc de la fiel es requerido";
                } else if(servicioObjetos.esObjetoVacio(empresa.contrasenaFiel)){
                    errores.contrasenaFiel="Campo requerido";
                }else {
                    try {
                        let validacionCertificado = validacionCertificadosDigitales(archivoCer.stringBase64, archivoKey.stringBase64, empresa.contrasenaFiel, empresa.rfcFiel, "FIEL");
                        empresa.fechaExpiracion = validacionCertificado.fechaFinal.getTime();
                        empresa.fechaCreacion = validacionCertificado.fechaInicial.getTime();
                    } catch (e) {
                        errores.contrasenaFiel = e.message;
                    }
                }
            }

        }
        return errores;
    }

    const validarTipoFiel = (event) => {
        handleChange(event, false);
        setArchivoCer({});
        setArchivoKey({});
        setArchivoPfx({});
    }

    const asignarArchivos = (objetoValidacion, archivo) => {
        return new Promise((resolve, reject) => {           
            obtenerObjetoBase64Archivos(objetoValidacion, archivo);
            resolve(objetoValidacion);
        });
    }

    const onDrop = (files) => {
        for (var i = 0; i < files.length; i++) {
            const archivo = files[i];
            if (archivo.name.toLowerCase().endsWith(".pfx")) {
                let objetoValidacion = {};               
                asignarArchivos(objetoValidacion,archivo).then(response => {
                    setTimeout(() => {
                        setArchivoPfx(response);
                     }, 50);
                });
            }
            if (archivo.name.toLowerCase().endsWith(".cer")) {
                let objetoValidacion = {};
                asignarArchivos(objetoValidacion,archivo).then(response => {                
                    setTimeout(() => {
                        setArchivoCer(response);
                     }, 50);
                });
            }
            if (archivo.name.toLowerCase().endsWith(".key")) {
                let objetoValidacion = {};
                asignarArchivos(objetoValidacion,archivo).then(response => {
                    setTimeout(() => {
                        setArchivoKey(response); 
                     }, 50);
                });
            }
            
        }
    }

    const validarCertificadoPfx = (archivoPfxB64, password) => {
        const validacionPfx = {};
        var p12Der = forge.util.decode64(archivoPfxB64);
        var p12Asn1 = forge.asn1.fromDer(p12Der);
        let p12 = null;
        try {
            p12 = forge.pkcs12.pkcs12FromAsn1(p12Asn1, password);
            var bags = p12.getBags({ bagType: forge.pki.oids.certBag });
            var certificado2 = bags[forge.pki.oids.certBag][1];
            validacionPfx.fecha = certificado2.cert.validity.notAfter;
            validacionPfx.error = false;
        } catch (e) {
            validacionPfx.error = true;
            validacionPfx.descripcionError = "La contraseña del archivo .pfx es incorrecta";
        }
        return validacionPfx;
    }

    const cerrarModalAuth= () => {
        setMostrarModalAuthResponse(false);
        setObjetoResponseAuth({});
    }


    const pieDialogoCertificado = <div className="ui-dialog-buttonpane p-clearfix">

        <Button
            label="Guardar"
            icon="pi-md-save"
            onClick={actualizarCertificados}
        />

        <Button
            label="Cancelar"
            icon="pi-md-close"
            onClick={cerrar}
            className="p-button-danger " />
    </div>;


    return (
        <div>
            <Growl ref={growl} />
            <ModalResponseAuthIdseImms mostrar={mostrarModalAuthResponse}
            funcionCerrar={cerrarModalAuth}
            objetoResponseAuth={objetoResponseAuth}/>
            <Dialog visible={mostrarModal}
                header="Carga de certificado"
                modal={true} footer={pieDialogoCertificado}
                onHide={cerrar} style={{ width: '80%' }}>
                <h4>Los campos con (*) son obligatorios, por favor captura los datos de la Empresa</h4>
                <div className="p-grid form-group">
                    <div className="p-col-12 p-md-12">
                        <RadioButton inputId="pfx" name="tipoCertificado" value="pfx"
                            onChange={validarTipoFiel}
                            checked={empresa.tipoCertificado === 'pfx'} />
                        <label htmlFor="pfx" className="p-radiobutton-label">Conectar con Certificado .PFX  </label>
                        <RadioButton inputId="fiel" name="tipoCertificado" value="fiel"
                            onChange={validarTipoFiel}
                            checked={empresa.tipoCertificado === 'fiel'} />
                        <label htmlFor="fiel" className="p-radiobutton-label">Conectar con Fiel</label>
                        {errores.tipoCertificado ? <div><Message severity="error" text={errores.tipoCertificado} /> </div> : null}
                    </div>

                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <InputText type="text" maxLength="200" id="usuario"
                                name="usuario" value={empresa.usuario || ""}
                                className={errores.usuario ? "p-error" : ""}
                                onChange={(e) => handleChange(e, false)} style={{ width: "90%" }} />
                            <label>* Usuario Idse:</label>
                            {errores.usuario ? <div><Message severity="error" text={errores.usuario} /> </div> : null}
                        </span>
                    </div>

                    {!servicioObjetos.esObjetoVacio(empresa.tipoCertificado) && empresa.tipoCertificado === "pfx" ?
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="password" maxLength="200" id="contrasenaPfx"
                                    name="contrasenaPfx" value={empresa.contrasenaPfx || ""}
                                    className={errores.contrasenaPfx ? "p-error" : ""}
                                    onChange={handleChange} style={{ width: "90%" }} />
                                <label>* Contraseña Certificado .PFX:</label>
                                {errores.contrasenaPfx ? <div>
                                    <Message severity="error" text={errores.contrasenaPfx} /> </div> : null}
                            </span>
                        </div> : null}


                    {!servicioObjetos.esObjetoVacio(empresa.tipoCertificado) && empresa.tipoCertificado === "fiel" ?
                        <div className="p-col-6 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="password" maxLength="200" id="contrasenaFiel"
                                    name="contrasenaFiel"
                                    value={empresa.contrasenaFiel || ""}
                                    className={errores.contrasenaFiel ? "p-error" : ""}
                                    onChange={handleChange} style={{ width: "90%" }} />
                                <label>* Contraseña Certificado FIEL:</label>
                                {errores.contrasenaFiel ? <div>
                                    <Message severity="error" text={errores.contrasenaFiel} /> </div> : null}
                            </span>
                        </div>

                        : null}

                    {!servicioObjetos.esObjetoVacio(empresa.tipoCertificado) && empresa.tipoCertificado === "fiel" ?
                        <div className="p-col-6 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="text" maxLength="13"
                                    id="rfcFiel" name="rfcFiel"
                                    value={empresa.rfcFiel || ""}
                                    className={errores.rfcFiel ? "p-error" : ""}
                                    onChange={(e) => handleChange(e, true)} style={{ width: "90%" }} />
                                <label>* Rfc de la FIEL:</label>
                                {errores.rfcFiel ? <div><Message
                                    severity="error" text={errores.rfcFiel} /> </div> : null}
                            </span>
                        </div>

                        : null}
                    {!servicioObjetos.esObjetoVacio(empresa.tipoCertificado) ?
                        <div className="p-col-12 p-md-12">
                            <Dropzone accept={empresa.tipoCertificado === 'pfx' ? ACEPTAR_PFX : ACEPTAR_FIEL} onDrop={onDrop}>
                                {({ getRootProps, getInputProps }) => (
                                    <section >
                                        <div  {...getRootProps({ className: 'dropzone rectangulo' })}>
                                            <input   {...getInputProps()} />
                                            <center><p>{servicioObjetos.esObjetoVacio(empresa.tipoCertificado) ? null :
                                                empresa.tipoCertificado === "fiel" ? MENSAJE_FIEL : MENSAJE_PFX}</p></center>
                                        </div>
                                        <br></br>
                                        {!servicioObjetos.esObjetoVacio(archivoPfx) ?
                                            <div><strong>{archivoPfx.nombre}</strong></div> : null}
                                        {!servicioObjetos.esObjetoVacio(archivoCer) ?
                                            <div><strong>{archivoCer.nombre}</strong></div> : null}
                                        {!servicioObjetos.esObjetoVacio(archivoKey) ?
                                            <div><strong>{archivoKey.nombre}</strong></div> : null}
                                    </section>
                                )}
                            </Dropzone>
                        </div> : null}
                </div>

            </Dialog>
        </div>
    );
}